import React, { useEffect, useCallback, useState} from 'react';
import SaveModal from "components/modals/SaveModal.js";
import {connect} from 'react-redux';

const SaveButton = ({sequencerEngine}) => { 
    let [show, setShow] = useState(false);
    const save = useCallback((name, saveOption, selectedGuild) => {
        sequencerEngine.save(name, saveOption, true, selectedGuild);
        setShow(false);
    }, [setShow, sequencerEngine]);
    return (
        <div>
          <SaveModal
            sequencerEngine={sequencerEngine}
            onSave={save}
            onHide={() => setShow(false)}
            show={show}/>
          <div onClick={() => setShow(true)}className="work-save-button">
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveButton);
